import React, { useState } from "react";

import Step1 from "./steps/Step1";
import Step2 from "./steps/Step2";
import Step3 from "./steps/Step3";
import Step4 from "./steps/Step4";
import Step5 from "./steps/Step5";
import StepsIndication from "./steps/stepParts/StepsIndication";

import {
    CALCULATOR_TYPES,
    getCalculatorType
} from "../services/helpers";
import ErrorModal from "./modals/ErrorModal";
import {useSelector} from "react-redux";
import {FormattedMessage} from "react-intl";



function Steps({
    openStep,
    loading,
    stepsState,
    onStepSubmit,
    dispatch,
    error,
    onStateClear
}) {
  //kan-ik-dit-huis-betalen
  //wat-worden-mijn-maandlasten
    const components = () => {
      let steps = {
        //Step1: Step5,
        Step1: Step1,
        Step2: Step2,
        Step3: Step3,
        Step4: Step4,
        Step5: Step5,
      };

      const calculatorType = getCalculatorType();
      if (calculatorType === CALCULATOR_TYPES.kanIkDitHuisBetalen) {
        steps = {
          Step1: Step3,
          Step2: Step1,
          Step3: Step4,
          Step4: Step2,
          Step5: Step5,
        };
      }
      if (calculatorType === CALCULATOR_TYPES.watWordenMijnMaandLasten) {
        steps = {
          Step1: Step3,
          Step2: Step1,
          Step3: Step2,
          Step4: Step5,
        };
      }

      return steps;
    };


    const [resetForms, setResetForms] = useState(() => false);
    const [showResetBtn, setShowResetBtn] = useState(() => false);
    const { summaryWithBanksOpened } = useSelector((state) => state.calculator);
    const steps = stepsState.map((item, i) => {
        const Component = components()[`Step${i + 1}`];
        return (
            <Component
                key={i}
                stepNumber={i}
                loading={loading}
                state={stepsState[i]}
                openStep={openStep}
                stepsState={stepsState}
                onStepSubmit={onStepSubmit}
                dispatch={dispatch}
                shouldReset={resetForms}
                setResetForms={setResetForms}
                setShowResetBtn={setShowResetBtn}
            />
        );
    });

    return (
        <div className={`ct-step__steps ${summaryWithBanksOpened ? "ct-step__steps__summary-opened" : undefined}`}>
            <StepsIndication stepsState={stepsState} />

            <div>
                {showResetBtn ? <button
                    className="ct-step__reset-button"
                    type="button"
                    onClick={() => {
                        setResetForms(true);
                        onStateClear();
                    }}
                >

                  <FormattedMessage id={"steps.resetAnswers"} defaultMessage={`Antwoorden wissen`} />
                </button> : null}

                {steps}
            </div>

            {error && <ErrorModal />}
            <div id="sidebar-portal" />
            <div id="loading-modal-portal" />
            <div id="overview-modal-portal" />
            <div id="income-calculator-modal-portal" />
        </div>
    );
}

export default Steps;
